module.exports = __webpack_public_path__ + "static/img/logo_en.c95b4f1e.png";